import { defineComponent as _defineComponent } from 'vue'
import { computed, useAsync, useRouter, useStore, watch } from "@nuxtjs/composition-api";

import { useAmplitude, useAuth } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { getLikesStore } from "@/store/likes";
import { getLtksStore } from "@/store/ltks";
import { hasValidTooltipReferral } from "@/utils/sessionstorage";
import { TOOLTIP_REFERRER_POST_PAGE_LIKE_TIMESTAMP } from "@/utils/sessionstorage/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkPostLike',
  props: {
  ltkId: { type: String, required: true },
  referringComponent: { type: String, required: false, default: "" },
  isRunway: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;



const auth = useAuth();
const store = useStore();
const amplitude = useAmplitude();
const router = useRouter();

const fetch = () => {
  if (auth.loggedIn) {
    getLikesStore(store).fetchLikeById(props.ltkId);
  }
};

const getReferringComponent = (): string => {
  if (hasValidTooltipReferral(TOOLTIP_REFERRER_POST_PAGE_LIKE_TIMESTAMP)) {
    return "post page - like post tooltip";
  }
  return props.referringComponent;
};

const onFavoriteChange = async () => {
  const ltkId = props.ltkId;
  const likesStore = getLikesStore(store);
  if (auth.loggedIn) {
    const payload: LtKFavoriteProps = {
      "ltk-id": ltkId,
      "profile-id": profileId.value || "",
      "referring-component": props.referringComponent,
      method: "CLICK",
    };
    if (isLtkLiked.value) {
      await likesStore.deleteLike({ ltkId });
      amplitude?.sendEvent("/unlike", payload);
    } else {
      await likesStore.createLike({ ltkId });
      amplitude?.sendEvent("/like", payload);
    }
  } else {
    localStorage.setItem("favorite-post", ltkId);
    getLikesStore(store).setLoggedOutFavLtkId(ltkId);
    getAmplitudeStore(store).setReferringComponent(getReferringComponent());
    router.push({ path: "/signup", query: { "shopltk-signup-prompt": "favorite-post" } });
  }
};

const profileId = computed(() => {
  const ltksStore = getLtksStore(store);
  return ltksStore.ltks[props.ltkId]?.profileId;
});

const isLtkLiked = computed(() => Boolean(getLikesStore(store).likes[props.ltkId]));

useAsync(() => fetch());

watch(
  () => props.ltkId,
  () => {
    fetch();
  },
);

return { __sfc: true,props, auth, store, amplitude, router, fetch, getReferringComponent, onFavoriteChange, profileId, isLtkLiked }
}

})